<script lang="ts" setup>
withDefaults(defineProps<{
  items?: string[]
}>(), {
  items: () => [],
})
</script>

<template>
  <ABreadcrumb class="container-breadcrumb">
    <ABreadcrumbItem>
      <IconApps />
    </ABreadcrumbItem>
    <ABreadcrumbItem v-for="item in items" :key="item">
      {{ item }}
    </ABreadcrumbItem>
  </ABreadcrumb>
</template>

<style scoped lang="less">
  .container-breadcrumb {
  :deep(.arco-breadcrumb-item) {
    color: rgb(var(--gray-6));
    &:last-child {
      color: rgb(var(--gray-8));
    }
  }
}
</style>
